export default [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/gtgw/index'),
    meta: {
      title: '瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/gtgw/profile'),
    meta: {
      title: '投资项目 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/enterprise',
    name: 'enterprise',
    component: () => import('../views/gtgw/enterprise'),
    meta: {
      title: '下属企业 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/gtgw/news'),
    meta: {
      title: '新闻中心 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/group',
    name: 'group',
    component: () => import('../views/gtgw/group'),
    meta: {
      title: '集团概况 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/gtgw/newsDetail'),
    meta: {
      title: '新闻详情 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('../views/gtgw/project'),
    meta: {
      title: '专题详情 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/projectList',
    name: 'projectList',
    component: () => import('../views/gtgw/projectList'),
    meta: {
      title: '专题专栏 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/gtgw/notice'),
    meta: {
      title: '通知公告 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/gtgw/map'),
    meta: {
      title: '网站地图 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/friendlyLink',
    name: 'friendlyLink',
    component: () => import('../views/gtgw/friendlyLink'),
    meta: {
      title: '友情链接 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/gtgw/contactUs'),
    meta: {
      title: '联系我们 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/law',
    name: 'law',
    component: () => import('../views/gtgw/law'),
    meta: {
      title: '法律声明 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/mailbox',
    name: 'mailbox',
    component: () => import('../views/gtgw/mailbox'),
    meta: {
      title: '廉政信箱 - 瑞安市国有资产投资集团有限公司'
    }
  },
  {
    path: '/submit',
    name: 'submit',
    component: () => import('../views/gtgw/submit'),
    meta: {
      title: '廉政信箱 - 瑞安市国有资产投资集团有限公司'
    }
  }
];
